/* @flow */
import ReactDOM from "react-dom";

// Wrap this unstable API so that we can rely on the signature as it changes.
export default function batchReactUpdates(updater: () => void): void {
  ReactDOM.unstable_batchedUpdates(updater);
}



// WEBPACK FOOTER //
// ./src/batchReactUpdates.js